<template>
	<div class="ce-iframe">
		<iframe width="100%" :src="objectdata.url"></iframe>
	</div>
</template>
<script>
	import Base from "./Base.vue";
	export default {
		extends: Base,
		props: {
			type: false,
			objectdata: {}
		},

		data() {
			return {};
		},
		created() {
			// this.init();
		},
		methods: {},
		composed: {
			getfullheadline() {
				return;
			}
		}
	};
</script>

<style lang="scss">
	@import "@/scss/variables.scss";
	@import "@/scss/mixins.scss";
	.ce-iframe {
		margin: 0 auto;
		overflow: hidden;
		// overflow-y: auto;
		// padding: 0 20px;
		padding: 0;
		max-width: $screen-min-content;
		// @include min-screen($screen-min-content) {
		// 	padding: 0;
		// }
		iframe {
			border: none;
			box-shadow: none;
			min-height: 1050px;
			width: 100%;
			@include min-screen(810px) {
				min-height: 1200px;
			}
		}
	}
</style>